// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.nav-title[data-v-6f96f336] {\n  font-weight: bold;\n  margin-top: 30px;\n  margin-bottom: 20px;\n}\n.update[data-v-6f96f336] {\n  position: absolute;\n  top: 5px;\n  right: 12px;\n  font-size: 12px;\n  color: #acacac;\n}\n", ""]);
// Exports
module.exports = exports;
